import { createContext, useContext, useReducer } from 'react';
import { ParlamentarianSearchState, ParlamentarianSearchReducer, ACTION_TYPES } from './parlamentarian-search-reducer';

const ParlamentarianSearchContext = createContext<ParlamentarianSearchState | undefined>(undefined);
const ParlamentarianSearchDispatchContext = createContext({} as any);

const ParlamentarianSearchProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: ParlamentarianSearchState = {
        parameters: { page: 0, pageSize: 100 },
        searchTrigger: 0,
    };
    const [state, dispatch] = useReducer(ParlamentarianSearchReducer, initialState);
    return (
        <ParlamentarianSearchContext.Provider value={state}>
            <ParlamentarianSearchDispatchContext.Provider value={dispatch}>
                {children}
            </ParlamentarianSearchDispatchContext.Provider>
        </ParlamentarianSearchContext.Provider>
    );
};

const useParlamentarianSearchState = () => {
    const context = useContext(ParlamentarianSearchContext);
    if (!context) throw new Error('useParlamentarianSearchState must be used within ParlamentarianSearchProvider');
    return context;
};

const useParlamentarianSearchDispatch = () => {
    const context = useContext(ParlamentarianSearchDispatchContext);
    if (!context) throw new Error('useParlamentarianSearchDispatch must be used within ParlamentarianSearchProvider');
    return context;
};

export { ParlamentarianSearchProvider, useParlamentarianSearchState, useParlamentarianSearchDispatch, ACTION_TYPES };
